// 环保管家首页
<template>
  <div class="eiaProtectionMap" id="eiaProtectionMap">
    <div class="arcgis-map-div" id="arcgisMapDiv">
      <div class="arcgis-map" id="mapView"></div>
      <div class="arcgis-timeslider" id="timeSliderView"></div>
    </div>
    <div class="measurementBar" id="topbarMeasure">
      <button
        class="action-button esri-icon-measure-line"
        id="distanceButton"
        type="button"
        title="测距离"
      ></button><br>
      <button
        class="action-button esri-icon-measure-area"
        id="areaButton"
        type="button"
        title="测面积"
      ></button>
    </div>
    <!-- <div class="provinceList" id="provinceListBar2D">
      <el-select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <el-option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </div>
    <div class="provinceList" id="provinceListBar3D">
      <el-select v-model="mapProvinceActive" placeholder="请选择" @change="provinceChange()">
        <el-option v-for="(item, index) in mapProvinceList" :key="index" :label="item" :value="item"></el-option>
      </el-select>
    </div> -->
  </div>
</template>

<script>
/* eslint-disable no-undef */
import api from '../../api/index'
import { loadModules } from 'esri-loader'
export default {
  props: ['protectionCenter'],
  data () {
    return {
      // 地图
      gisAppliView: null,
      gisBackupViewParams: null,
      gisMap: null,
      gisMapView: null,
      gisScene: null,
      gisSceneView: null,
      gisWMTSLayer: null,
      gisWMTSLayerScene: null,
      gisWMTSLayer1: null,
      gisWMTSLayerScene1: null,
      gisWMTSLayer2: null,
      gisWMTSLayerScene2: null,
      tdtIBOLayer: null,
      tdtCIALayer: null,
      tdtCVALayer: null,
      tdtIBOLayerScene: null,
      tdtCIALayerScene: null,
      tdtCVALayerScene: null,
      // gisVectorTileLayerScene: null,
      gisSearch: null,
      gisSearchScene: null,
      gisSketchsLayer: null,
      gisStationsLayer: null,
      gisGraphicsLayer: null,
      gisSketch: null,
      mapProvinceActive: '北京市',
      mapProvinceList: [
        '北京市', '天津市', '河北省', '山西省', '内蒙古自治区',
        '辽宁省', '吉林省', '黑龙江省',
        '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省',
        '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '海南省',
        '四川省', '贵州省', '云南省', '西藏自治区', '重庆市',
        '陕西省', '甘肃省', '青海省', '宁夏回族自治区', '新疆维吾尔自治区'
      ],
      activeWidget: null,
      crtBaseMap: 'streets-relief-vector',
      mapLayerType: 'WMTS',
      mapLayerTypeArr: ['none', 'WMTS'],
      mapSatelliteGorT: 'google',
      viewDimensionType: '2d',
      mapFullScreenFlag: false,
      tdtTk: 'daf534f80a571d37738cc8e681b1e2cd',
      // data
      // protPos: [120.123456, 30.123456]
      protPos: this.protectionCenter
    }
  },
  mounted () {
    // api.appUserMapProvinceEnquiry().then(res => {
    //   this.mapProvinceActive = res.data
    this.mapinit()
    // })
  },
  methods: {
    mapinit () {
      loadModules([
        'esri/Map',
        'esri/views/MapView',
        'esri/Basemap',
        'esri/views/SceneView',
        'esri/layers/WMTSLayer',
        // 'esri/layers/VectorTileLayer',
        'esri/layers/GraphicsLayer',
        'esri/layers/WebTileLayer',
        'esri/widgets/Compass',
        'esri/widgets/Search',
        // 'esri/widgets/Sketch',
        'esri/widgets/ScaleBar'
      ], { css: true }).then(([
        ArcGISMap,
        MapView,
        Basemap,
        SceneView,
        WMTSLayer,
        // VectorTileLayer,
        GraphicsLayer,
        WebTileLayer,
        Compass,
        Search,
        // Sketch,
        ScaleBar
      ]) => {
        this.initView(Basemap, ArcGISMap, MapView, SceneView, WebTileLayer)
        // 2D地图视图对象
        this.gisMapView = new MapView({
          center: [116.391349, 39.907375],
          map: this.gisMap,
          zoom: 17
        })
        // 3D地图视图对象
        this.gisSceneView = new SceneView({
          center: [116.391349, 39.907375],
          map: this.gisScene,
          zoom: 17
        })
        // 切换2d/3d
        this.gisAppliView = {
          mapView: null,
          sceneView: null,
          activeView: null,
          container: document.getElementById('mapView')
          // container: null
        }
        this.gisBackupViewParams = {
          zoom: 17,
          center: [116.391349, 39.907375]
          // container: this.gisAppliView.document
        }
        this.gisAppliView.mapView = this.gisMapView
        this.gisAppliView.sceneView = this.gisSceneView
        this.gisAppliView.activeView = this.gisAppliView.mapView
        this.gisAppliView.activeView.container = this.gisAppliView.container
        // WMTS图层
        this.gisWMTSLayer1 = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          // copyright:
          //   '<a href=\'https://www.arcgis.com/index.html\'>Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisWMTSLayer2 = new WebTileLayer({ // 天地图影像
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          // copyright: '天地图影像',
          visible: false
        })
        // this.gisWMTSLayer = this.gisWMTSLayer1
        this.gisMap.addMany([this.gisWMTSLayer1, this.gisWMTSLayer2])
        this.gisWMTSLayerScene1 = new WMTSLayer({
          url: 'https://wayback.maptiles.arcgis.com/arcgis/rest/services/world_imagery/wmts',
          // copyright:
          //   '<a href=\'https://www.arcgis.com/index.html\'>Earthdata</a> by Esri',
          activeLayer: {
            id: 'SRTM_Color_Index'
          }
        })
        this.gisWMTSLayerScene2 = new WebTileLayer({ // 天地图影像
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          // copyright: '天地图影像',
          visible: false
        })
        // this.gisWMTSLayerScene = this.gisWMTSLayerScene1
        this.gisScene.addMany([this.gisWMTSLayerScene1, this.gisWMTSLayerScene2])
        // 天地图标注图层
        this.tdtIBOLayer = new WebTileLayer({ // 天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-全球境界'
        })
        this.tdtCIALayer = new WebTileLayer({ // 天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-影像注记'
        })
        this.tdtCVALayer = new WebTileLayer({ // 天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '天地图-矢量注记'
        })
        this.tdtIBOLayerScene = new WebTileLayer({ // 3d天地图-全球境界
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/ibo_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=ibo&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-全球境界'
        })
        this.tdtCIALayerScene = new WebTileLayer({ // 3d天地图-影像注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-影像注记'
        })
        this.tdtCVALayerScene = new WebTileLayer({ // 3d天地图-矢量注记
          urlTemplate: 'https://{subDomain}.tianditu.gov.cn/cva_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cva&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILEMATRIX={level}&TILEROW={row}&TILECOL={col}&tk=' + this.tdtTk,
          subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
          title: '3d天地图-矢量注记'
        })
        this.gisMap.addMany([this.tdtIBOLayer, this.tdtCIALayer, this.tdtCVALayer])
        this.gisScene.addMany([this.tdtIBOLayerScene, this.tdtCIALayerScene, this.tdtCVALayerScene])
        // 创建图层
        this.gisSketchsLayer = new GraphicsLayer({ title: '草图图层' })
        this.gisStationsLayer = new GraphicsLayer({ title: '站点图层' })
        this.gisGraphicsLayer = new GraphicsLayer({ title: '几何图层' })
        this.gisMap.addMany([this.gisGraphicsLayer, this.gisStationsLayer, this.gisSketchsLayer])
        // 3d图层
        this.gisSketchsLayerScene = new GraphicsLayer({ title: '3d草图图层' })
        this.gisStationsLayerScene = new GraphicsLayer({ title: '3d站点图层' })
        this.gisGraphicsLayerScene = new GraphicsLayer({ title: '3d几何图层' })
        this.gisGraphicsLayerSceneAux = new GraphicsLayer({ title: '3d辅助几何图层' })
        this.gisScene.addMany([this.gisGraphicsLayerSceneAux, this.gisGraphicsLayerScene, this.gisStationsLayerScene, this.gisSketchsLayerScene])
        // 2d自定义控件
        // this.gisMapView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 3 })
        this.gisMapView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 4 })
        this.gisMapView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 5 })
        this.gisMapView.ui.add(this.setSwitchSitelliteBtn(), { position: 'top-left', index: 6 })
        // this.gisMapView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 7 })
        // this.gisMapView.ui.add(this.setCreateObjBtn(), { position: 'top-right', index: 2 })
        // this.gisMapView.ui.add('provinceListBar2D', { position: 'bottom-right', index: 1 })
        // // 3d
        // // this.gisSceneView.ui.add(this.setFullScreenBtn(), { position: 'top-left', index: 2 })
        // this.gisSceneView.ui.add(this.setSwitchMapBtn(), { position: 'top-left', index: 3 })
        // this.gisSceneView.ui.add(this.setSwitchOSMBtn(), { position: 'top-left', index: 4 })
        // this.gisSceneView.ui.add(this.setSwitchSitelliteBtn(), { position: 'top-left', index: 5 })
        // // this.gisSceneView.ui.add(this.setSwitchDBtn(), { position: 'top-left', index: 6 })
        // // this.gisSceneView.ui.add('provinceListBar3D', { position: 'bottom-right', index: 0 })
        // 搜索
        this.gisSearch = new Search({ view: this.gisMapView })
        this.gisSearch.on('search-start', (event) => {
          this.gisMapView.popup.open({
            actions: []
          })
        })
        this.gisMapView.ui.add(this.gisSearch, { position: 'top-left', index: 0 })
        this.gisSearchScene = new Search({ view: this.gisSceneView })
        this.gisSearchScene.on('search-start', (event) => {
          this.gisSceneView.popup.open({
            actions: []
          })
        })
        this.gisSceneView.ui.add(this.gisSearchScene, { position: 'top-left', index: 0 })
        // 指南针
        const gisCompass = new Compass({
          view: this.gisMapView
        })
        this.gisMapView.ui.add(gisCompass, 'top-left')
        // 比例尺
        var scaleBar = new ScaleBar({
          view: this.gisMapView,
          style: 'rule',
          unit: 'metric'
        })
        this.gisMapView.ui.add(scaleBar, 'bottom-right')
        // // 绘图工具
        // this.gisSketch = new Sketch({
        //   layer: this.gisSketchsLayer,
        //   view: this.gisMapView,
        //   availableCreateTools: ['point', 'polygon', 'rectangle', 'circle'],
        //   creationMode: 'update'
        // })
        // this.gisMapView.ui.add(this.gisSketch, 'top-right')
        // this.gisSketchCreateObjs(this.gisSketch, webMercatorUtils)
        // 测量
        this.gisMeasurement()
        // 添加覆盖物
        this.addGraphics()
        // init popup
        this.initPopup()
        // 点击事件
        this.initClickEvt()
      })
    },
    initView (Basemap, ArcGISMap, MapView, SceneView, WebTileLayer) {
      this.gisAppliView = {
        mapView: null,
        sceneView: null,
        activeView: null,
        container: document.getElementById('mapView')
      }
      this.gisBackupViewParams = {
        map: null,
        zoom: 17,
        center: [120, 30],
        container: null
      }
      // basemap
      // const baseMap = new Basemap({
      //   portalItem: {
      //     id: 'bc19c34549de4000bcd91cef929420dc'
      //   }
      // })
      const baseMap2d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7']
        // copyright: '天地图底图'
      })
      const baseMap3d = new WebTileLayer({ // 天地图影像
        urlTemplate: 'https://{subDomain}.tianditu.gov.cn/vec_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=vec&STYLE=default&TILEMATRIXSET=w&FORMAT=tiles&TILECOL={col}&TILEROW={row}&TILEMATRIX={level}&tk=' + this.tdtTk,
        subDomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7']
        // copyright: '天地图底图'
      })
      // 2D地图底图
      this.gisMap = new ArcGISMap({
        // basemap: this.crtBaseMap
        layers: [baseMap2d]
      })
      // 3D地图底图
      this.gisScene = new ArcGISMap({
        // basemap: baseMap,
        // basemap: 'satellite',
        layers: [baseMap3d],
        ground: 'world-elevation'
      })
      // init 2d mapView
      this.gisBackupViewParams.map = this.gisMap
      this.gisBackupViewParams.container = this.gisAppliView.container
      // this.gisAppliView.mapView = new MapView(this.gisBackupViewParams)
      this.gisAppliView.mapView = new MapView({
        map: this.gisMap,
        zoom: 17,
        center: [120, 30],
        container: this.gisAppliView.container
      })
      // init 3d sceneView
      this.gisBackupViewParams.map = this.gisScene
      this.gisBackupViewParams.container = null
      // this.gisAppliView.sceneView = new SceneView(this.gisBackupViewParams)
      this.gisAppliView.sceneView = new SceneView({
        map: this.gisScene,
        zoom: 17,
        center: [120.00000000, 30.00000000],
        container: null
      })
    },
    // 初始化弹窗
    initPopup () {
      this.gisMapView.popup.autoOpenEnabled = false
      this.gisSceneView.popup.autoOpenEnabled = false
      var popupOnEvt = (evt) => {
        console.log(evt, this.selectedData)
        switch (evt.action.id) {
          case 'deleteBtnG':
            this.$confirm('确定删除该图形?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              api.hbCoverInterfaceDelete({
                id: this.selectedData.id
              }).then((resD) => {
                if (resD.code === 200) {
                  this.addGraphics()
                  this.gisMapView.popup.close()
                  this.gisSceneView.popup.close()
                  this.$message({
                    type: 'success',
                    message: '删除成功'
                  })
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
            break
        }
      }
      this.gisMapView.popup.on('trigger-action', popupOnEvt)
      this.gisSceneView.popup.on('trigger-action', popupOnEvt)
      console.log('initPopupCompleted')
    },
    // 点击事件
    initClickEvt () {
      // this.gisMapView.popup.autoOpenEnabled = false
      var clickEvt = (evt) => {
        this.gisMapView.popup.close()
        this.gisSceneView.popup.close()
        var lngLat = {
          // 'longitude': webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[0],
          // 'latitude': webMercatorUtils.xyToLngLat(evt.mapPoint.x, evt.mapPoint.y)[1]
          latitude: evt.mapPoint.latitude,
          longitude: evt.mapPoint.longitude
        }
        console.log('lngLat', lngLat, evt)
        var openEvt = {
          title: '点击位置',
          content:
            `<p>坐标：${this.lnglatD2DMS(lngLat)} (${Math.round(lngLat.longitude * 1000000) / 1000000}, ${Math.round(lngLat.latitude * 1000000) / 1000000})`,
          location: evt.mapPoint,
          actions: []
        }
        this.gisMapView.popup.open(openEvt)
        // this.gisSceneView.popup.open(openEvt)
        var hitTestEvt = (response) => {
          console.log(response)
          // if (response.results.length) {
          //   var graphicData = response.results[0].graphic.attributes.data
          //   var layer = response.results[0].graphic.layer.title
          //   console.log(layer, graphicData)
          //   if (layer === '几何图层' || layer === '3d几何图层') {
          //     this.clickGraphics(graphicData, response.results[0])
          //   }
          // }
        }
        this.gisMapView.hitTest(evt).then(hitTestEvt)
        // this.gisSceneView.hitTest(evt).then(hitTestEvt)
      }
      this.gisMapView.on('click', clickEvt)
      // this.gisSceneView.on('click', clickEvt)
    },
    // 自定义组件
    // setFullScreenBtn () {
    //   var btn = document.createElement('img')
    //   btn.src = require('@/assets/mapicons/fullScreenEnter.png')
    //   btn.title = '进入全屏'
    //   btn.style.width = '32px'
    //   btn.style.height = '32px'
    //   btn.style.borderTop = 'solid 1px #cccccc'
    //   btn.style.cursor = 'pointer'
    //   btn.onclick = () => {
    //     const mapContainer = document.getElementById('ehsmapwrap')
    //     // const arcgisMapDiv = document.getElementById('arcgisMapDiv')
    //     if (this.mapFullScreenFlag) {
    //       document.webkitCancelFullScreen()
    //       btn.src = require('@/assets/mapicons/fullScreenEnter.png')
    //       btn.title = '进入全屏'
    //       // arcgisMapDiv.style.height = 'calc(100vh - 130px)'
    //     } else {
    //       mapContainer.webkitRequestFullScreen()
    //       btn.src = require('@/assets/mapicons/fullScreenExit.png')
    //       btn.title = '退出全屏'
    //       // arcgisMapDiv.style.height = 'calc(100vh - 40px)'
    //     }
    //     this.mapFullScreenFlag = !this.mapFullScreenFlag
    //   }
    //   this.fullScreenBtn = btn
    //   return this.fullScreenBtn
    // },
    // 切换显示图层
    setSwitchMapBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/mapSwitch.png')
      btn.title = '切换地图'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.style.borderBottom = '1px solid #cccccc'
      btn.onclick = () => {
        // if (this.viewDimensionType === '2d') {
        // this.changePType()
        var index = this.mapLayerTypeArr.indexOf(this.mapLayerType)
        this.mapLayerType = index < this.mapLayerTypeArr.length - 1 ? this.mapLayerTypeArr[++index] : this.mapLayerTypeArr[0]
        if (this.mapLayerType === 'WMTS') {
          this[`gisWMTSLayer${this.mapSatelliteGorT}`].visible = true
          this[`gisWMTSLayerScene${this.mapSatelliteGorT}`].visible = true
          this.tdtIBOLayer.visible = this.tdtCVALayer.visible
          this.tdtCIALayer.visible = this.tdtCVALayer.visible
          this.tdtIBOLayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCIALayerScene.visible = this.tdtCVALayerScene.visible
          this.tdtCVALayer.visible = false
          this.tdtCVALayerScene.visible = false
        } else {
          this[`gisWMTSLayer${this.mapSatelliteGorT}`].visible = false
          this[`gisWMTSLayerScene${this.mapSatelliteGorT}`].visible = false
          this.tdtCVALayer.visible = this.tdtCIALayer.visible
          this.tdtCVALayerScene.visible = this.tdtCIALayerScene.visible
          this.tdtIBOLayer.visible = false
          this.tdtCIALayer.visible = false
          this.tdtIBOLayerScene.visible = false
          this.tdtCIALayerScene.visible = false
        }
        // }
      }
      this.switchMapBtn = btn
      return this.switchMapBtn
    },
    setSwitchOSMBtn () {
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/osm.png')
      btn.title = '显示/隐藏路网'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      btn.style.marginBottom = '0'
      btn.style.borderBottom = '1px solid #cccccc'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        if (this.mapLayerType === 'WMTS') {
          this.tdtIBOLayer.visible = !this.tdtIBOLayer.visible
          this.tdtCIALayer.visible = !this.tdtCIALayer.visible
          this.tdtIBOLayerScene.visible = !this.tdtIBOLayerScene.visible
          this.tdtCIALayerScene.visible = !this.tdtCIALayerScene.visible
        } else {
          this.tdtCVALayer.visible = !this.tdtCVALayer.visible
          this.tdtCVALayerScene.visible = !this.tdtCVALayerScene.visible
        }
      }
      this.switchOSMBtn = btn
      return this.switchOSMBtn
    },
    setSwitchSitelliteBtn () {
      this.mapSatelliteGorT = '1'
      var btn = document.createElement('img')
      btn.src = require('@/assets/mapicons/earth.png')
      btn.title = '切换卫星图源'
      btn.style.width = '32px'
      btn.style.height = '32px'
      btn.style.cursor = 'pointer'
      // btn.style.marginBottom = '0'
      btn.onclick = () => {
        console.log('this.mapSatelliteGorT', this.mapSatelliteGorT)
        if (this.mapLayerType === 'WMTS') {
          if (this.mapSatelliteGorT === '1') {
            this.gisWMTSLayer1.visible = false
            this.gisWMTSLayerScene1.visible = false
            this.gisWMTSLayer2.visible = true
            this.gisWMTSLayerScene2.visible = true
            this.mapSatelliteGorT = '2'
          } else if (this.mapSatelliteGorT === '2') {
            this.gisWMTSLayer1.visible = true
            this.gisWMTSLayerScene1.visible = true
            this.gisWMTSLayer2.visible = false
            this.gisWMTSLayerScene2.visible = false
            this.mapSatelliteGorT = '1'
          }
        }
      }
      this.switchSatelliteBtn = btn
      return this.switchSatelliteBtn
    },
    // setSwitchDBtn () {
    //   var btn = document.createElement('img')
    //   btn.src = require('@/assets/mapicons/3D.png')
    //   btn.title = '切换为3D'
    //   btn.style.width = '32px'
    //   btn.style.height = '32px'
    //   btn.style.cursor = 'pointer'
    //   // btn.style.marginBottom = '0'
    //   btn.onclick = () => {
    //     this.gisBackupViewParams.center = this.gisAppliView.activeView.center
    //     this.gisBackupViewParams.scale = Math.round(this.gisAppliView.activeView.scale)
    //     this.gisAppliView.sceneView.scale = this.gisBackupViewParams.scale
    //     this.gisAppliView.mapView.scale = this.gisBackupViewParams.scale
    //     this.gisAppliView.activeView.container = null
    //     this.$nextTick().then(() => {
    //       if (this.viewDimensionType === '2d') {
    //         this.gisAppliView.sceneView.center = this.gisBackupViewParams.center
    //         this.gisAppliView.activeView = this.gisAppliView.sceneView
    //         this.gisAppliView.activeView.container = this.gisAppliView.container
    //         this.switchDBtn.title = '切换为2D'
    //         this.switchDBtn.src = require('@/assets/mapicons/2D.png')
    //         this.viewDimensionType = '3d'
    //       } else {
    //         this.gisAppliView.mapView.center = this.gisBackupViewParams.center
    //         this.gisAppliView.activeView = this.gisAppliView.mapView
    //         this.gisAppliView.activeView.container = this.gisAppliView.container
    //         this.switchDBtn.title = '切换为3D'
    //         this.switchDBtn.src = require('@/assets/mapicons/3D.png')
    //         this.viewDimensionType = '2d'
    //       }
    //       this.addGraphics()
    //     })
    //   }
    //   this.switchDBtn = btn
    //   return this.switchDBtn
    // },
    gisMeasurement () {
      var that = this
      loadModules([
        'esri/widgets/DistanceMeasurement2D',
        'esri/widgets/AreaMeasurement2D'
      ], { css: true }).then(([
        DistanceMeasurement2D,
        AreaMeasurement2D
      ]) => {
        that.gisMapView.ui.add('topbarMeasure', { position: 'top-right', index: 0 })
        document.getElementById('distanceButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('distance')
          } else {
            setActiveButton(null)
          }
        })
        document.getElementById('areaButton').addEventListener('click', function () {
          setActiveWidget(null)
          if (!this.classList.contains('active')) {
            setActiveWidget('area')
          } else {
            setActiveButton(null)
          }
        })
        function setActiveWidget (type) {
          switch (type) {
            case 'distance':
              that.activeWidget = new DistanceMeasurement2D({
                view: that.gisMapView
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('distanceButton'))
              break
            case 'area':
              that.activeWidget = new AreaMeasurement2D({
                view: that.gisMapView,
                label: '测距离'
              })
              // skip the initial 'new measurement' button
              that.activeWidget.viewModel.start()
              that.gisMapView.ui.add(that.activeWidget, 'top-right')
              setActiveButton(document.getElementById('areaButton'))
              break
            case null:
              if (that.activeWidget) {
                that.gisMapView.ui.remove(that.activeWidget)
                that.activeWidget.destroy()
                that.activeWidget = null
              }
              break
          }
        }
        function setActiveButton (selectedButton) {
          // focus the view to activate keyboard shortcuts for sketching
          that.gisMapView.focus()
          var elements = document.getElementsByClassName('active')
          for (var i = 0; i < elements.length; i++) {
            elements[i].classList.remove('active')
          }
          if (selectedButton) {
            selectedButton.classList.add('active')
          }
        }
      })
    },
    // 格式转换器
    lnglatD2DMS (mtlnglat) {
      var mtLng = mtlnglat.longitude
      var mtLat = mtlnglat.latitude
      var d, m, s, t, lng, lat, lnglat
      d = parseInt(mtLng)
      m = parseInt((mtLng - d) * 60)
      s = Math.round(((mtLng - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'E'
      } else {
        t = 'W'
        d = -d
      }
      lng = d + '°' + m + '\'' + s + '"' + t
      d = parseInt(mtLat)
      m = parseInt((mtLat - d) * 60)
      s = Math.round(((mtLat - d) * 60 - m) * 60)
      if (d >= 0) {
        t = 'N'
      } else {
        t = 'S'
        d = -d
      }
      lat = d + '°' + m + '\'' + s + '"' + t
      lnglat = lng + ', ' + lat
      return lnglat
    },
    colorHArr2DArr (colorHArr) {
      var colorDArr = []
      JSON.parse(colorHArr).forEach((item) => {
        var dItem = Number(parseInt(item, 16).toString(10))
        colorDArr.push(dItem)
      })
      return colorDArr
    },
    colorHStr2HArr (colorHStr) {
      if (!colorHStr) {
        return ['00', '00', '00']
      } else {
        var colorHArr = [
          colorHStr.slice(1, 3),
          colorHStr.slice(3, 5),
          colorHStr.slice(5, 7)
        ]
        return colorHArr
      }
    },
    colorHStr2DArr (colorHStr) {
      var colorDArr = [
        Number(parseInt(colorHStr.slice(1, 3), 16).toString(10)),
        Number(parseInt(colorHStr.slice(3, 5), 16).toString(10)),
        Number(parseInt(colorHStr.slice(5, 7), 16).toString(10))
      ]
      return colorDArr
    },
    dateUTC2GMT08 (dateUTC) {
      var gmt08T = dateUTC.toLocaleTimeString('chinese', { hour12: false })
      var gmt08DArr = dateUTC.toLocaleDateString().split('/')
      var y = gmt08DArr[0]
      var m = gmt08DArr[1] < 10 ? '0' + gmt08DArr[1] : gmt08DArr[1]
      var d = gmt08DArr[2] < 10 ? '0' + gmt08DArr[2] : gmt08DArr[2]
      var gmt08 = y + '-' + m + '-' + d + ' ' + gmt08T
      return gmt08
    },
    // add
    addGraphics (addType) {
      loadModules([
        'esri/Graphic',
        'esri/geometry/Circle'
      ], { css: true }).then(([
        Graphic,
        GeometryCircle
      ]) => {
        this.gisGraphicsLayer.removeAll()
        // this.gisGraphicsLayerScene.removeAll()
        // this.gisGraphicsLayerSceneAux.removeAll()
        this.addPCenter(Graphic, GeometryCircle)
        // this.addPoints(Graphic, resG.data.pointOptions)
        // this.addObjAreas(Graphic, resG.data.objAreaOptions)
        // this.addBuildings(Graphic, resG.data.buildingOptions)
        // this.addCylinders(Graphic, GeometryCircle, resG.data.cylinderOptions)
        // this.gisSketch.delete()
        this.gisSearch.searchTerm = `${this.protPos[0]}, ${this.protPos[1]}`
        this.gisSearch.search()
        console.log('delete completed')
      })
    },
    addPCenter (Graphic, GeometryCircle) {
      console.log('addPCenter')
      // 50m
      var circle50m = new Graphic({
        geometry: new GeometryCircle({
          center: this.protPos,
          geodesic: true,
          numberOfPoints: 32,
          radius: 50,
          radiusUnit: 'meters'
        }),
        symbol: {
          type: 'simple-fill',
          color: [255, 255, 0, 0.2],
          outline: {
            width: 1,
            color: [255, 255, 0, 0.6]
          }
        }
      })
      this.gisGraphicsLayer.add(circle50m)
      // 500m
      var circle500m = new Graphic({
        geometry: new GeometryCircle({
          center: this.protPos,
          geodesic: true,
          numberOfPoints: 32,
          radius: 500,
          radiusUnit: 'meters'
        }),
        symbol: {
          type: 'simple-fill',
          color: [255, 0, 0, 0.2],
          outline: {
            width: 1,
            color: [255, 0, 0, 0.6]
          }
        }
      })
      this.gisGraphicsLayer.add(circle500m)
      // cenP
      var cenPoint = new Graphic({
        geometry: {
          type: 'point',
          longitude: this.protPos[0],
          latitude: this.protPos[1]
        },
        symbol: {
          type: 'simple-marker',
          color: [255, 0, 0, 1],
          size: 10,
          outline: {
            color: [255, 255, 255, 0.8],
            width: 1
          }
        },
        popupTemplate: {
          title: 'title'
        }
      })
      this.gisGraphicsLayer.add(cenPoint)
    },
    // addPoints (Graphic, data) {
    //   data.forEach(item => {
    //     var pos = JSON.parse(item.center)
    //     var plsymbolType = item.symbolType || 'default'
    //     var getAltPoint = new Graphic({
    //       geometry: {
    //         type: 'point',
    //         longitude: pos[0],
    //         latitude: pos[1]
    //       }
    //     })
    //     this.gisScene.ground.queryElevation(getAltPoint.geometry).then(resAlt => {
    //       var posZ = Number(resAlt.geometry.z.toFixed(1))
    //       var symbol = {}
    //       switch (plsymbolType) {
    //         // case 'solidwaste':
    //         //   var smb = this.markerIconList.solidwasteicon
    //         //   symbol = {
    //         //     type: 'picture-marker',
    //         //     url: smb,
    //         //     width: '32px',
    //         //     height: '32px'
    //         //   }
    //         //   posZ += 15
    //         //   break
    //         case 'default':
    //         default:
    //           symbol = {
    //             type: 'simple-marker',
    //             color: [...this.colorHArr2DArr(item.colorHArr), 0.8],
    //             size: 6,
    //             outline: {
    //               color: [255, 255, 255, 0.8],
    //               width: 1
    //             }
    //           }
    //           break
    //       }
    //       var point = new Graphic({
    //         geometry: {
    //           type: 'point',
    //           longitude: pos[0],
    //           latitude: pos[1],
    //           z: posZ + 75
    //         },
    //         symbol: symbol,
    //         attributes: {
    //           data: item
    //         },
    //         popupTemplate: {
    //           title: 'title'
    //         }
    //       })
    //       if (this.viewDimensionType === '2d') {
    //         this.gisGraphicsLayer.add(point)
    //       } else {
    //         this.gisGraphicsLayerScene.graphics.add(point)
    //         var polyline = new Graphic({
    //           geometry: {
    //             type: 'polyline',
    //             paths: [
    //               [pos[0], pos[1], 0],
    //               [pos[0], pos[1], posZ + 75]
    //             ]
    //           },
    //           symbol: {
    //             type: 'simple-line',
    //             color: [...this.colorHArr2DArr(item.colorHArr), 0.5],
    //             width: 2
    //           }
    //         })
    //         this.gisGraphicsLayerScene.graphics.add(polyline)
    //       }
    //       console.log('addPoint', point)
    //     })
    //   })
    // },
    // addObjAreas (Graphic, data) {
    //   data.forEach(item => {
    //     var polygon = new Graphic({
    //       geometry: {
    //         type: 'polygon',
    //         rings: JSON.parse(item.path)
    //       },
    //       symbol: {
    //         type: 'simple-fill', // autocasts as new SimpleFillSymbol()
    //         color: [...this.colorHArr2DArr(item.colorHArr), 0.3],
    //         outline: {
    //           color: [...this.colorHArr2DArr(item.colorHArr), 1],
    //           width: 1
    //         }
    //       },
    //       attributes: {
    //         data: item
    //       }
    //     })
    //     if (this.viewDimensionType === '2d') {
    //       this.gisGraphicsLayer.graphics.add(polygon)
    //     } else {
    //       this.gisGraphicsLayerScene.graphics.add(polygon)
    //     }
    //   })
    //   console.log('addObjAreas completed', data)
    // },
    // addBuildings (Graphic, data) {
    //   data.forEach(item => {
    //     var dataRings = JSON.parse(item.bounds)
    //     var rings = []
    //     if (this.viewDimensionType === '2d') {
    //       rings = dataRings
    //     } else {
    //       var tempArr = []
    //       for (var i = 0; i < dataRings.length; i++) {
    //         var iErr = i + 1
    //         if (i >= dataRings.length - 1) { iErr = 0 }
    //         var getAltPointi = new Graphic({
    //           geometry: {
    //             type: 'point',
    //             longitude: dataRings[i][0],
    //             latitude: dataRings[i][1]
    //           }
    //         })
    //         this.gisScene.ground.queryElevation(getAltPointi.geometry).then(resAlti => {
    //           var posZi = Number(resAlti.geometry.z.toFixed(1))
    //           var getAltPointiErr = new Graphic({
    //             geometry: {
    //               type: 'point',
    //               longitude: dataRings[iErr][0],
    //               latitude: dataRings[iErr][1]
    //             }
    //           })
    //           this.gisScene.ground.queryElevation(getAltPointiErr.geometry).then(resAltiErr => {
    //             var posZiErr = Number(resAltiErr.geometry.z.toFixed(1))
    //             // 顶面
    //             var ringItem = dataRings[i]
    //             ringItem.push(item.height + posZi)
    //             tempArr.push(ringItem)
    //             // 侧面
    //             var bErr = 0.000000001
    //             var iair0t = [dataRings[i][0], dataRings[i][1], item.height + posZi]
    //             var iair0b = [dataRings[i][0] + bErr, dataRings[i][1] + bErr, posZi]
    //             var iair1t = [dataRings[iErr][0], dataRings[iErr][1], item.height + posZiErr]
    //             var iair1b = [dataRings[iErr][0] + bErr, dataRings[iErr][1] + bErr, posZiErr]
    //             var itemAuxItemRings = [iair0t, iair1t, iair1b, iair0b]
    //             // console.log('itemAuxItemRings', iErr, itemAuxItemRings)
    //             var itemAuxItem = new Graphic({
    //               geometry: {
    //                 type: 'polygon',
    //                 rings: itemAuxItemRings
    //               },
    //               symbol: {
    //                 type: 'simple-fill', // autocasts as new SimpleFillSymbol()
    //                 color: [...this.colorHArr2DArr(item.colorHArr), 0.5],
    //                 outline: {
    //                   color: [...this.colorHArr2DArr(item.colorHArr), 1],
    //                   width: 1
    //                 }
    //               }
    //             })
    //             this.gisGraphicsLayerSceneAux.graphics.add(itemAuxItem)
    //             if (i === dataRings.length - 1) {
    //               rings = tempArr
    //               var polygon = new Graphic({
    //                 geometry: {
    //                   type: 'polygon',
    //                   rings: rings
    //                 },
    //                 symbol: {
    //                   type: 'simple-fill', // autocasts as new SimpleFillSymbol()
    //                   color: [...this.colorHArr2DArr(item.colorHArr), 0.7],
    //                   outline: {
    //                     color: [...this.colorHArr2DArr(item.colorHArr), 1],
    //                     width: 1
    //                   }
    //                 },
    //                 attributes: {
    //                   data: item
    //                 },
    //                 popupTemplate: {
    //                   title: 'title'
    //                 }
    //               })
    //               if (this.viewDimensionType === '2d') {
    //                 this.gisGraphicsLayer.graphics.add(polygon)
    //               } else {
    //                 this.gisGraphicsLayerScene.graphics.add(polygon)
    //               }
    //               console.log('addBuildings completed', data)
    //             }
    //           })
    //         })
    //       }
    //     }
    //   })
    // },
    clickGraphics (data, clkData) {
      var cPos = {
        longitude: clkData.graphic.geometry.centroid.longitude,
        latitude: clkData.graphic.geometry.centroid.latitude,
        z: data.height
      }
      this.selectedData = data
      var titleName
      switch (data.mapObjType) {
        case 'objArea':
          titleName = '区域'
          break
        case 'building':
          titleName = '建筑物'
          break
        case 'cylinder':
          titleName = '建筑物'
          break
      }
      this.gisMapView.popup.open({
        title: titleName,
        // content: '<p>坐标：' + JSON.stringify(lngLat), // content displayed in the popup
        content:
          `<p>中点坐标：${this.lnglatD2DMS(cPos)} (${Math.round(cPos.longitude * 1000000) / 1000000}, ${Math.round(cPos.latitude * 1000000) / 1000000})`,
        // location: evt.mapPoint // Set the location of the popup to the clicked location
        location: cPos,
        actions: []
      })
    }
  },
  beforeDestroy () {
    console.log('beforeDestroy')
  },
  watch: {
    '$route' (to, from) { // 检测路由地址变化
      console.log(`watchRouteLeaveFrom${from.path}To${to.path}xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxy`)
      if (to.path !== '/ehsHome') {
        var that = this
        that.$destroy()
        console.log(`watchRouteLeaveFrom${from.path}To${to.path}yyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyyy`)
        // console.log('watchRouteLeaveTo')
      }
    },
    protectionCenter (nv, ov) {
      console.log('protectionCenter', nv)
      this.protPos = nv
    },
    protPos (nv, ov) {
      console.log('protPos', nv)
      this.addGraphics()
    }
  },
  components: {}
}
</script>

<style lang="scss">
.eiaProtectionMap{
  // height: calc(100% - 32px);
  height: 100%;
  width: 100%;
  background: #c0dfff;
  .arcgis-map-div{
    // display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .arcgis-map{
      width: 100%;
      height: calc(100% + 16px);
      // border: 4px solid #008888;
      .esri-view-root{
        .esri-ui{
          .esri-ui-inner-container{
            .esri-ui-top-left{
              // .esri-search{
              //   margin-bottom: -32px;
              //   margin-left : 42px;
              // }
              .esri-navigation-toggle{
                margin-top: -74px;
                margin-left: 42px;
              }
            }
            .esri-ui-bottom-left{
              .esri-time-slider{
                width: 40%;
                .esri-time-slider__row{
                  height: 32px;
                  .esri-time-slider__animation,
                  .esri-time-slider__previous,
                  .esri-time-slider__next{
                    width: 32px;
                  }
                  .esri-time-slider__time-extent{
                    width: 160px;
                  }
                  .esri-time-slider__min,
                  .esri-time-slider__max{
                    width: 0;
                  }
                  .esri-time-slider__slider{
                    padding: 6px 16px;
                    .esri-slider{
                      margin: 0;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .measurementBar{
    background: #fff;
    .action-button {
      font-size: 16px;
      background-color: transparent;
      border: 0 solid #d3d3d3;
      color: #6e6e6e;
      height: 32px;
      width: 32px;
      text-align: center;
      box-shadow: 0 0 1px rgba(0, 0, 0, 0.3);
    }
    .action-button:hover,
    .action-button:focus {
      background: #007fff;
      color: #e4e4e4;
    }
    .action-button.active {
      background: #007fff;
      color: #e4e4e4;
    }
  }
}
</style>
